import * as React from "react"
import { Link } from "gatsby"
import styled from "styled-components"

import Layout from "../components/layout"
import Seo from "../components/seo"
import Wrapper from "../components/wrapper"
import SectionTitle from "../components/sectionTitle"
import text from "../constants/labels.json"
import PlaceCard from "../components/placeCard"
import jardinBotanico from "../images/jardinBotanico.jpg"
import estadioRegional from "../images/estadioRegional.jpeg"
import miradorBiodiversidad from "../images/miradorBiodiversidad.jpg"

const Ciencias = () => (
  <Layout>
    <Seo title="Ciencias" />
    <Background>
      <Wrapper>
        <Container>
          <SectionTitle title={text.labels.pages.science} textColor="#26272d" />
          <PlaceTitle>Estos son los lugares a visitar:</PlaceTitle>
          <SectionContainer>
            <InfoSection>
              <PlaceCard
                picSrc={jardinBotanico}
                cardColor="#6fa73b"
                title={text.labels.info.places.science.places.jardin.title}
                placeInfo={
                  text.labels.info.places.science.places.jardin.description
                }
                placeLink={text.labels.info.places.science.places.jardin.link}
                buttonTextColor="#f5f4f4"
                buttonBgColor="#e7b84c"
                buttonHoverColor="#f2c45a"
                buttonActiveColor="#c79b38"
                isRight={false}
              />
              <PlaceCard
                picSrc={estadioRegional}
                cardColor="#6fa73b"
                title={text.labels.info.places.science.places.estadio.title}
                placeInfo={
                  text.labels.info.places.science.places.estadio.description
                }
                placeLink={text.labels.info.places.science.places.estadio.link}
                buttonTextColor="#f5f4f4"
                buttonBgColor="#e7b84c"
                buttonHoverColor="#f2c45a"
                buttonActiveColor="#c79b38"
                isRight={true}
              />
              <PlaceCard
                picSrc={miradorBiodiversidad}
                cardColor="#6fa73b"
                title={
                  text.labels.info.places.science.places.museoMirador.title
                }
                placeInfo={
                  text.labels.info.places.science.places.museoMirador
                    .description
                }
                placeLink={
                  text.labels.info.places.science.places.museoMirador.link
                }
                buttonTextColor="#f5f4f4"
                buttonBgColor="#e7b84c"
                buttonHoverColor="#f2c45a"
                buttonActiveColor="#c79b38"
                isRight={false}
              />
              <StyledLink to="/">Volver a la página principal</StyledLink>
            </InfoSection>
          </SectionContainer>
        </Container>
      </Wrapper>
    </Background>
  </Layout>
)

const Container = styled.div`
  margin-top: 200px;
  @media screen and (max-width: 770px) {
    margin-top: 50px;
  }
`
const PlaceTitle = styled.h3`
  margin-top: 45px;
  text-align: center;
`
const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 650px;
  font-size: 1.15rem;
  line-height: 2rem;
  @media screen and (max-width: 900px) {
    width: 100%;
  }
`
const SectionContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 80px;
`
const StyledLink = styled(Link)`
  text-align: center;
  margin-top: 50px;
  margin-bottom: 30px;
  text-decoration: none;
`
const Background = styled.div`
  background-color: #c5e5a7;
  padding-top: 50px;`

export default Ciencias
